// extracted by mini-css-extract-plugin
export default {"button":"components-Button-button-module__button--MZz07","title":"components-Button-button-module__title--Td2cI","buttonImg":"components-Button-button-module__buttonImg--ogogd"};